import React from 'react';
import { Typography, Row, Col } from 'antd';
import Icon, { EnvironmentOutlined } from '@ant-design/icons';
import styles from './InfoBar.module.less';
import i18next from '../../i18next';
import Button from '../Button/Button';

type InfoBarProps = {
  isButtonVisible: boolean;
  onButtonClick: () => void;
  title?: string;
  text?: string;
};

const InfoBar = ({ title, text, isButtonVisible, onButtonClick }: InfoBarProps) => (
  <>
    {isButtonVisible ? (
      <div className={styles.buttonContainer}>
        <Button size="middle" onClick={onButtonClick} type="default">
          {i18next.t('deliveries.mapCaption.setLocationOnMap')}
        </Button>
      </div>
    ) : (
      <div className={styles.infoBar}>
        <Row>
          <Col className={styles.iconContainer} span={2}>
            <Icon className={styles.icon} component={() => <EnvironmentOutlined />} />
          </Col>
          <Col span={22}>
            <Row>
              <Typography.Text className={styles.title} strong>
                {title}
              </Typography.Text>
            </Row>
            <Row>
              <Typography.Text className={styles.text}>{text}</Typography.Text>
            </Row>
          </Col>
        </Row>
      </div>
    )}
  </>
);

export default InfoBar;
